import Random from "@frog/source/utility/Random.js"

/////////////
// RANGES //
///////////

const ranges = {
    "close-range": {
        "min": 1,
        "max": 1,
        "orthogonal": true,
        "diagonal": false,
    },
    "mid-range": {
        "min": 2,
        "max": 2,
        "orthogonal": true,
        // "diagonal": true,
        "diagonal": false,
        "type": "arc",
    },
    "long-range": {
        "min": 2,
        "max": 4,
        "orthogonal": true,
        "diagonal": false,
        "type": "arc",
    },
    "diag-mid-range": {
        // "min": 2,
        // "max": 2,
        // "orthogonal": true,
        // "diagonal": true,
        "min": 1, "max": 1,
        "directions": [
            {"x": -2, "order": 0},
            {"x": +2, "order": 1},
            {"y": -2, "order": 2},
            {"y": +2, "order": 3},
            {"x": -1, "y": +1, "order": 4},
            {"x": +1, "y": +1, "order": 5},
            {"x": -1, "y": -1, "order": 6},
            {"x": +1, "y": -1, "order": 7},
        ],
        "type": "arc",
    },
    "northsouth-range": {
        "min": 1,
        "max": 6,
        "directions": [
            {"y": -1},
            {"y": +1},
        ],
        // "orthogonal": true,
        // // "diagonal": true,
        // "diagonal": false,
        "type": "arc",
    },
    "eastwest-range": {
        "min": 1,
        "max": 1,
        "directions": [
            {"order": 0},
            {"x": -1, "order": 1},
            {"x": -2, "order": 2},
            {"x": -3, "order": 3},
            {"x": -4, "order": 4},
            {"x": -5, "order": 5},
            {"x": -6, "order": 6},
            {"x": +1, "order": 1},
            {"x": +2, "order": 2},
            {"x": +3, "order": 3},
            {"x": +4, "order": 4},
            {"x": +5, "order": 5},
            {"x": +6, "order": 6},
        ],
        // "orthogonal": true,
        // "diagonal": false,
        "type": "arc",
    },
    "cross-range": {
        // "min": 1,
        // "max": 2,
        // "orthogonal": true,
        "min": 1, "max": 1,
        "directions": [
            {"order": 0},
            {"x": -1, "order": 1},
            {"x": -2, "order": 2},
            {"y": -1, "order": 1},
            {"y": -2, "order": 2},
            {"x": +1, "order": 1},
            {"x": +2, "order": 2},
            {"y": +1, "order": 1},
            {"y": +2, "order": 2},
        ],
        "type": "arc"
    },
    "x-range": {
        "min": 1,
        "max": 2,
        "directions": [
            {"x": -1, "y": +1},
            {"x": +1, "y": -1},
            {"x": +1, "y": +1},
            {"x": -1, "y": -1},
        ],
        // "orthogonal": false,
        // "diagonal": true,
        "type": "arc"
    },
    "line": {
        "min": 1,
        "max": 5,
        "orthogonal": true,
        "diagonal": false,
        "type": "line",
    }
}

/////////////
// SKILLS //
///////////

const skills = {}
export default skills

skills["attack"] = {
    "key": "attack",
    "type": "attack",
    "animation": "strike",
    "range": ranges["close-range"],
    "power": 1,
    "calculateDeltastages": function({performerKey, effectKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []
        deltastages.push({
            "annotation": {
                "type": "swing",
                "unitReference": performer.reference,
                "direction": direction,
                "startPosition": performer.position,
                "endPosition": position,
                "unitKey": performer.key
            },
            // "units": {[performerKey]: {"inventory": {"count": -1}}}
        })

        const target = findUnitAtPosition(stage, position)
        if(target != undefined) {
            const baseDamage = -1 * (this.power + performer.power)

            deltastages.push({
                "annotation": {
                    "type": "inflict damage",
                    "direction": direction
                },
                "units": {[target.key]: {"health": -1}},
                // "event": "inflict damage",
                // "direction": direction,
                // "unit": {
                //     "key": target.key,
                //     "health": -1,
                // }
            })
        }

        return deltastages
    },
    "name": "Attack",
    "description": function() {
        return "Deals " + this.power + " damage."
    },
}

function findUnitInDirection(stage, position, direction, range) {
    let distance = 0
    let vector = {"x": 0, "y": 0}
    let previousPosition = Geometry.add(position, vector)
    let nextPosition = Geometry.add(position, vector, direction)

    while(hasCollision(stage, previousPosition, nextPosition, {"isIgnoringLedges": true}) == false) {
        distance += 1
        if(range != undefined && distance >= range.max) break
        vector = Geometry.multiply(direction, distance)
        previousPosition = Geometry.add(position, vector)
        nextPosition = Geometry.add(position, vector, direction)
    }

    // if(distance == 0) couldn't go far in any direction, but did find a direction
    if(World.hasCollision(stage.world, previousPosition, nextPosition, {"isIgnoringLedges": true}) == true) {
        // FOUND A COLLISION
    } else if(findUnitAtPosition(stage, nextPosition) != undefined) {
        return findUnitAtPosition(stage, nextPosition)
    }

}

skills["gun-push"] = {
    "key": "gun-push",
    "type": "attack",
    "animation": "gun-push",
    "range": {
        "min": 1,
        "max": 6,
        "orthogonal": true,
        "diagonal": false,
        "line": true,
    },
    "power": 1,
    // "canTarget": function({performerKey, stage, position}) {
    //     const performer = stage.units[performerKey]
    //     const target = findUnitAtPosition(stage, position)
    //     if(target == undefined) return false
    //     if(target.affiliation != performer.affiliation) return false
    //     return true
    // },
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []

        const target = findUnitInDirection(stage, performer.position, direction, this.range)
        if(target == undefined) {
            const toPosition = Geometry.add(performer.position, Geometry.multiply(direction, this.range.max))
            deltastages.push({
                "annotation": {"type": "swing", "direction": direction, "unitKey": performer.key, "unitReference": performer.reference, "fromPosition": performer.position, "toPosition": toPosition, "projectileDistance": this.range.max},
                "units": {[performer.key]: {}}
            })
            return deltastages
        }

        const distance = Geometry.distance(performer.position, target.position)

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "unitKey": performer.key, "unitReference": performer.reference, "fromPosition": performer.position, "toPosition": target.position, "projectileDistance": distance},
            "units": {[performer.key]: {}}
        })

        if(hasCollision(stage, target.position, Geometry.add(target.position, direction), {"isIgnoringLedges": true}) == false) {
            deltastages.push({
                "annotation": {"type": "push", "direction": direction, "vector": direction, "unitKey": target.key, "unitReference": target.reference, "projectileDistance": distance},
                "units": {[target.key]: {"position": direction}}
            })
            // TODO: Enable pushing for multiple tiles, assuming there isn't any collision
        } else {
            deltastages.push({
                "annotation": {"type": "nudge", "direction": direction, "unitKey": target.key, "unitReference": target.reference, "projectileDistance": distance},
                "units": {[target.key]: {}}
            })
        }

        return deltastages
    },
    "name": "Push",
    "description": function() {
        return "Pushes an ally [" + this.power + "] tile" + (this.power > 1 ? "s" : "") + "."
    }
}

skills["gun-pull"] = {
    "key": "gun-pull",
    "type": "attack",
    "animation": "gun-pull",
    "range": {
        "min": 1,
        "max": 3,
        "orthogonal": true,
        // "diagonal": true,
        // "line": true,
        // "directions": [
        //     {"x": 0, "y": -2},
        //     {"x": 0, "y": -3},
        //     {"x": 0, "y": 2},
        //     {"x": 0, "y": 3},
        //     {"x": -2, "y": 0},
        //     {"x": -3, "y": 0},
        //     {"x": 2, "y": 0},
        //     {"x": 3, "y": 0},
        //     {"x": -2, "y": -1},
        //     {"x": -1, "y": -2},
        //     {"x": 2, "y": 1},
        //     {"x": 1, "y": 2},
        //     {"x": -2, "y": 1},
        //     {"x": -1, "y": 2},
        //     {"x": 2, "y": -1},
        //     {"x": 1, "y": -2},
        // ],
    },
    "power": 1,
    // "canTarget": function({performerKey, stage, position}) {
    //     const performer = stage.units[performerKey]
    //     const target = findUnitAtPosition(stage, position)
    //     if(target == undefined) return false
    //     if(target.affiliation != performer.affiliation) return false
    //     const previousPosition = performer.position
    //     const direction = Geometry.direction(position, performer.position)
    //     const nextDirection = Geometry.flip(direction)
    //     const nextPosition = Geometry.add(previousPosition, nextDirection)
    //     return hasCollision(stage, previousPosition, nextPosition) == false
    // },
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []

        const target = findUnitInDirection(stage, performer.position, direction, this.range)
        if(target == undefined) {
            deltastages.push({
                "annotation": {"type": "swing", "direction": direction, "unitKey": performer.key, "unitReference": performer.reference, "fromPosition": performer.position, "projectileDistance": this.range.max},
                "units": {[performer.key]: {}}
            })
            return deltastages
        }

        const projectileDistance = Geometry.distance(performer.position, target.position)

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "unitKey": performer.key, "unitReference": performer.reference, "fromPosition": performer.position, "projectileDistance": projectileDistance},
            "units": {[performer.key]: {}}
        })

        const nextTargetPosition = Geometry.add(performer.position, direction)
        const vector = Geometry.difference(nextTargetPosition, target.position)
        const vectorDistance = Geometry.distance(nextTargetPosition, target.position)

        if(Geometry.equals(nextTargetPosition, target.position)) {
            deltastages.push({
                "annotation": {"type": "nudge", "direction": Geometry.flip(direction), "unitKey": target.key, "projectileDistance": projectileDistance},
                "units": {[target.key]: {}}
            })
        } else {
            deltastages.push({
                "annotation": {"type": "push", "direction": Geometry.flip(direction), "vector": vector, "unitKey": target.key, "vectorDistance": vectorDistance, "projectileDistance": projectileDistance},
                "units": {
                    [target.key]: {"position": vector},
                }
            })
        }

        return deltastages
    },
    "name": "Pull",
    "description": "Pulls an ally backwards [1] tile.",
}

skills["gun-burst"] = {
    "key": "gun-burst",
    "type": "attack",
    "animation": "gun-burst",
    "range": {
        "min": 1,
        "max": 1,
        "orthogonal": true,
        "diagonal": false,
    },
    "power": 1,
    // TODO: write a .canTarget like the other basic sumo moves?
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)

        const deltastages = []

        deltastages.push({
            "annotation": {"type": "swing", "direction": direction, "unitKey": performer.key, "unitReference": performer.reference, "fromPosition": performer.position},
            "units": {[performer.key]: {}}
        })

        const forces = []
        forces.push({
            "position": position,
            "direction": direction
        })
        forces.push({
            "position": Geometry.add(position, Geometry.perpendicular(direction)),
            "direction": Geometry.perpendicular(direction)
        })
        forces.push({
            "position": Geometry.add(position, Geometry.flip(Geometry.perpendicular(direction))),
            "direction": Geometry.flip(Geometry.perpendicular(direction)),
        })

        forces.forEach((force) => {
            const target = findUnitAtPosition(stage, force.position)
            if(target == undefined) {
                return
            }

            if(hasCollision(stage, target.position, Geometry.add(target.position, force.direction), {"isIgnoringCollsion": false}) == false) {
                deltastages.push({
                    "annotation": {"type": "push", "direction": force.direction, "vector": force.direction, "unitKey": target.key, "unitReference": target.reference},
                    "units": {[target.key]: {"position": force.direction}}
                })
            } else {
                deltastages.push({
                    "annotation": {"type": "nudge", "direction": force.direction, "unitKey": target.key, "unitReference": target.reference},
                    "units": {[target.key]: {}}
                })
            }
        })

        return deltastages
    },
    "name": "Burst",
    "description": "Pushes a bunch of adjacent units",
}

skills["bomb-throw"] = {
    "key": "bomb-throw",
    "type": "attack",
    "animation": "bomb-throw",
    "range": {
        "min": 2,
        "max": 2,
        "orthogonal": false, // !!!
        "diagonal": true,
        "type": "arc",
    },
    "power": 1,
    "timer": 2,
    "canTarget": function({performerKey, stage, position}) {
        if(findUnitAtPosition(stage, position) != undefined) return false
        const terrain = World.getTerrain(stage.world, position)
        if(terrain == undefined) return false
        if(terrain.hasCollision) return false
        if(terrain.hasSafezone) return false
        if(terrain.size.z != 4) return false // HARD CODED TO CORRECT LEVEL
        return true
    },
    "calculateDeltastages": function({performerKey, stage, position}) {
        const performer = stage.units[performerKey]
        const direction = Geometry.direction(position, performer.position)
        const projectileDistance = Geometry.distance(performer.position, position)

        const deltastages = []

        deltastages.push({
            "annotation": {
                "type": "swing",
                "unitKey": performer.key,
                "startPosition": performer.position,
                "fromPosition": performer.position,
                "endPosition": position,
                "toPosition": position,
                "distance": Geometry.distance(performer.position, position),
                "unitReference": performer.reference,
                "direction": direction,
                "projectileDistance": projectileDistance
            }
        })

        const unit = {
            "position": position,
            "reference": "bomb",
            "key": shortid.generate(), // THIS IS DUPED WITH THE EVENTUALY UNIT.INSTANTIATE CALL, BUT WE NEED IT FOR THE DELTASTAGES SCHEMA :<
            "power": this.power, // is this in replacement of range? can we convey all range values with just power?
        }

        unit.mode = "create" // TODO: WE ADD THIS... TO THE DELTAUNIT?? THIS SHOULD BE OUTSIDE THE PAYLOAD.
        deltastages.push({
            "annotation": {"type": "place-unit", unit},
            "units": {[unit.key]: unit}
        })

        return deltastages
    },
    "name": function() {
        if(this.power >= 2) return "Throw Big Bomb!!"
        return "Throw Bomb"
    },
    "description": function() {
        if(this.power >= 2) return "Throws a bomb. It explodes at the start of your next turn... for 2 tiles!"
        return "Throws a bomb. It explodes at the start of your next turn."
        // return "Toss a bomb [" + this.range.max + "] tiles away. It explodes at the start of your next turn."
    }
}

// skills["spawn-bomber"] = {
//     "key": "spawn-bomber",
//     "type": "on-death",
// }

skills["explode"] = {
    "key": "explode",
    "type": "at-my-end-of-turn",
    "animation": "explode",
    "range": {
        "min": 1,
        "max": 3,
        "orthogonal": true,
        "diagonal": false,
    },
    "calculateStep": function({stage, performerKey, effectKey, position}) {
        const step = Step.instantiate({
            "type": "invoke skill",
            "skillKey": "explode", // I hate this
            "alphastage": stage
        })

        const performer = step.omegastage.units[performerKey]

        position = performer.position

        const explosions = [{"position": position, "power": 3, "directions": directions}]
        const hasExploded = {}
        while(explosions.length > 0) {
            const explosion = explosions.shift()
            explosion.distance = explosion.distance || 0

            if(World.hasCollision(stage.world, explosion.position, explosion.position)) {
                continue
            }
            const terrain = World.getTerrain(stage.world, explosion.position)
            if(terrain == undefined) {
                continue
            }
            if(terrain.hasSafezone == true) {
                continue
            }
            hasExploded[Geometry.toString(explosion.position)] = explosion

            const unit = findUnitAtPosition(stage, explosion.position)
            if(unit != undefined) {
                if(unit.reference == "bomb"
                && unit.key != performerKey) {
                    explosion.power = Math.max(explosion.power, unit.power)
                    explosion.directions = directions.filter((direction) => Geometry.equals(direction, Geometry.flip(explosion.directions[0])) == false)
                }
                // Do not pierce through boxes.
                if(unit.class == "egg") { // IS SOFT BOX BLOCK
                    explosion.power = 0
                }
                // destroy the unit or box or bomb.
                explosion.unit = unit
            }

            if(explosion.power > 0) {
                explosion.directions.forEach((direction) => {
                    const nextPosition = Geometry.add(explosion.position, direction)
                    if(hasExploded[Geometry.toString(nextPosition)] != undefined) return
                    explosions.push({
                        "power": explosion.power - 1,
                        "distance": explosion.distance + 1,
                        "directions": [direction],
                        "position": nextPosition
                    })
                })
            }
        }

        Step.add(step, {"annotation": {"type": "sound"}})
        Objdict.forEach(hasExploded, (explosion) => {
            Step.add(step, {"annotation": {"type": "explode", "position": explosion.position, "distance": explosion.distance, "performerKey": performer.key}})
            if(explosion.unit != undefined) {
                Step.add(step, {"annotation": {"type": "remove", "distance": explosion.distance, "unitKey": explosion.unit.key, "unitReference": explosion.unit.reference}, "units": {[explosion.unit.key]: {"health": -100, "isDead": true}}})
                if(explosion.unit.class == "egg") {
                    const unit = {
                        "position": explosion.unit.position,
                        "reference": "bomber",
                        "key": shortid.generate(), // THIS IS DUPED WITH THE EVENTUALY UNIT.INSTANTIATE CALL, BUT WE NEED IT FOR THE DELTASTAGES SCHEMA :<
                    }
                    unit.mode = "create" // TODO: WE ADD THIS... TO THE DELTAUNIT?? THIS SHOULD BE OUTSIDE THE PAYLOAD.
                    const deltastage = {"annotation": {"type": "spawn", "unit": unit, "distance": explosion.distance}, "units": {[unit.key]: unit}}
                    Step.add(step, deltastage)
                }
            }
        })

        return step
    },
}

//////////////
// UTILITY //
////////////

// https://gist.github.com/ehgoodenough/e329ceb141294e6b0f1fd375acf973fe

import World  from "@frog/source/models/World.js"

import shortid from "shortid"

import Elements from "@frog/source/data/elements.js"
import Geometry from "@frog/source/utility/Geometry.js"
import * as Objdict from "objdict"
import Unit from "@frog/source/models/Unit.js"
import Step from "@frog/source/models/Step.js"

function findUnitAtPosition(stage, nextPosition) {
    const unit = Objdict.find(stage.units, (unit) => {
        return unit.position.x == nextPosition.x
            && unit.position.y == nextPosition.y
            && unit.position.z == nextPosition.z
            && unit.isDead != true
            && unit.health > 0
    })
    return unit
}

function hasCollision(stage, previousPosition, nextPosition, options) {
    if(World.hasCollision(stage.world, previousPosition, nextPosition, options)) {
        return true
    }
    if(findUnitAtPosition(stage, nextPosition)) {
        return true
    }
    return false
}

const directions = [{"x": +1}, {"x": -1}, {"y": +1}, {"y": -1}]
// TODO: merge this with utilities/Directions.js? Pull them from Geometry.north/etc?

function raycast({stage, position, direction, distance = Infinity}) {
    let currentDistance = 0
    let currentVector = {"x": 0, "y": 0}
    let currentPosition = position
    while(currentDistance < distance == true) {
        if(World.hasCollision(stage.world, currentPosition, Geometry.add(currentPosition, direction))) {
            return {
                "collision": {
                    "position": Geometry.add(currentPosition, direction),
                    "type": "world"
                },
                "ray": {
                    "startPosition": position,
                    "endPosition": currentPosition,
                    "distance": currentDistance,
                    "direction": direction,
                    "vector": currentVector,
                }
            }
        }
        const unit = findUnitAtPosition(stage, Geometry.add(currentPosition, direction))
        if(unit != undefined) {
            return {
                "collision": {
                    "position": Geometry.add(currentPosition, direction),
                    "unit": unit,
                },
                "ray": {
                    "startPosition": position,
                    "endPosition": currentPosition,
                    "distance": currentDistance,
                    "direction": direction,
                    "vector": currentVector,
                }
            }
        }
        currentVector = Geometry.add(currentVector, direction)
        currentPosition = Geometry.add(currentPosition, direction)
        currentDistance += 1
    }
    return {
        "ray": {
            "startPosition": position,
            "endPosition": currentPosition,
            "distance": currentDistance,
            "direction": direction,
            "vector": currentVector,
        }
    }
}

function calculateTrapPositions({stage, position, range}) {
    const positions = []

    if(range == undefined) return positions

    range.directions = range.directions || directions
    range.directions.forEach((direction) => {
        const distance = Math.abs(direction.x || 0) + Math.abs(direction.y || 0)
        let previousPosition = position
        for(let i = range.min; i <= range.max; i += 1) {
            const nextPosition = Geometry.add(position, Geometry.multiply(direction, i / distance))

            if(range.type != "arc"
            && World.hasCollision(stage.world, previousPosition, nextPosition) == true) {
                return
            }

            const unit = findUnitAtPosition(stage, nextPosition)
            if(unit != undefined) {
                // Do not pierce through boxes. ??? BOMBER
                if(unit.family == "box") { // IS SOFT BOX BLOCK
                    return
                }
            }

            positions.push(nextPosition)
            previousPosition = nextPosition
        }
    })

    // let chargeAmount = 0
    // let chargeVector = {"x": 0, "y": 0}
    // let chargePosition = position
    // while(chargeAmount < distance == true
    // // && hasCollision(stage, chargePosition, Geometry.add(chargePosition, direction)) == false) {
    // && World.hasCollision(stage.world, chargePosition, Geometry.add(chargePosition, direction)) == false) {
    //     chargeVector = Geometry.add(chargeVector, direction)
    //     chargePosition = Geometry.add(position, chargeVector)
    //     chargeAmount += 1
    //     positions.push(chargePosition)
    // }
    return positions
}

function recalculateEffects(stage, unit, deltaunit) {
    deltaunit.effects = deltaunit.effects || {}
    let position = deltaunit.position
    // console.log(deltaunit)
    if(deltaunit.mode == "relative"
    || deltaunit.mode == undefined) { // defaulting to relative
        position = Geometry.add(unit.position, deltaunit.position)
        // TODO: if this was a reaction, we could just piggyback off
        // of the delta computed stuff. This assume it was a reaction
        // system outside of the skill and in the action calculation,
        // and not just layers of layers of logic in the skills like
        // it currently is.
    }
    Objdict.forEach(unit.effects, (effect, effectKey) => {
        if(effect.type == "trap" || effect.type == "traplike") {
            deltaunit.effects[effectKey] = {
                "positions": calculateTrapPositions({
                    "stage": stage,
                    "range": effect.range,
                    "position": position
                })
            }
        }
    })
}

// SKILL SCHEMA v4 MUST SUPPORT:
// deconstructed parameter signature for target, performer and action.
// only being passed performerKey and action, not the explicit target keys.
// being able to be run on tile without a unit to target, returning nothing.
// must declare key in results. cannot rely on old target/performer shorcuts.
// must declare key relative to stage schema, so deltastage.units[key] = deltaunit
// can return a single delta or an array of deltas for separating into animations
// must handle reactions like traps or death?

class Range {
    static copy(a) {
        const b = {}
        for(let key in a) {
            b[key] = a[key]
        }
        return b
    }
}

const elements = {
    "fire-type": {"element": "fire"},
    "water-type": {"element": "water"},
    "grass-type": {"element": "grass"},
    "ground-type": {"element": "ground"},
    "metal-type": {"element": "metal"},
    "lightning-type": {"element": "lightning"},
}

const potencies = {
    "mad-potent": {"potency": "mad"},
    "mild-potent": {"potency": "mild"},
}

// TODO: ARE WE REALLY making individual
// dictionaries for each and every stat?
const timers = {
    "3-timer": {"timer": 3},
    "2-timer": {"timer": 2},
    "1-timer": {"timer": 1},
}

const targets = {
    "enemy-only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation != performer.affiliation
        }
    },
    "ally-only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return target.affiliation == performer.affiliation
        }
    },
    "enemy-or-empty-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation != performer.affiliation
        }
    },
    "ally-or-empty-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return true
            return target.affiliation == performer.affiliation
        }
    },
    "only-target": {
        "canTarget": function({performerKey, stage, position}) {
            const performer = stage.units[performerKey]
            const target = findUnitAtPosition(stage, position)
            if(target == undefined) return false
            return true
        }
    },
    "all-target": {
        "canTarget": function({performerKey, stage, position}) {
            return true
        }
    },
}

skills.get = function(skillKey) {
    if(skillKey == undefined) {
        return undefined
    }
    if(skills[skillKey] != undefined) {
        return skills[skillKey]
    }

    let skill = {}
    skillKey.split(" ").forEach((skillPart) => {
        if(skills[skillPart] != undefined) {
            skill = Objdict.merge(skill, skills[skillPart])
        }
        if(skillPart.endsWith("-power")) {
            skill = Objdict.merge(skill, {"power": parseInt(skillPart)})
        }
        if(skillPart.endsWith("-type")) {
            skill = Objdict.merge(skill, elements[skillPart] || {})
        }
        if(skillPart.endsWith("-range")) {
            skill = Objdict.merge(skill, {"range": ranges[skillPart]})
        }
        if(skillPart.endsWith("-potent")) {
            skill = Objdict.merge(skill, potencies[skillPart] || {})
        }
        if(skillPart.endsWith("-timer")) {
            skill = Objdict.merge(skill, timers[skillPart] || {})
        }
        if(skillPart == "inflictsFlinch") { // ONLY WORKS WITH STRIKE RIGHT NOW
            skill = Objdict.merge(skill, {"inflictsFlinch": true})
        }
        if(skillPart.endsWith("-target")) {
            skill = Objdict.merge(skill, targets[skillPart])
        }
        if(skillPart.endsWith("-variant")) {
            const string = "-variant"
            skill = Objdict.merge(skill, {
                "variant": skillPart.substring(0, skillPart.length - string.length)
            })
        }
        if(skillPart == "generic-animation") {
            skill = Objdict.merge(skill, {
                "animation": "generic"
            })
        }
    })
    skills[skillKey] = skill
    return skill
}
